export default "__VITE_ASSET__BQqgITQI__"